import React from 'react'
import Button from 'components/Button'
import { useToast } from 'components/Toast'
import CodeEditor from 'components/CodeEditor'

export default function AdminPanelOnboarding({ data, onSave, isSaving }) {
  const [onboarding, setOnboarding] = React.useState(
    JSON.stringify(data.onboarding, null, 4) || ''
  )
  const openToast = useToast()
  function validateAndSave(onboarding) {
    try {
      onboarding = JSON.parse(onboarding)
      onSave({ onboarding })
    } catch (err) {
      openToast({
        type: 'error',
        text: 'Error updating! Please ensure JSON is valid',
      })
    }
  }
  return (
    <div className="flex flex-col items-start flex-1 w-full">
      <div className="flex flex-row flex-wrap w-full notranslate">
        <CodeEditor
          placeholder="You can edit your Onboarding settings here."
          mode="json"
          value={onboarding}
          onChange={setOnboarding}
          name="shop_onboarding_editor"
        />
      </div>
      <Button
        size="small"
        loading={isSaving}
        onClick={() => validateAndSave(onboarding)}
      >
        Save
      </Button>
    </div>
  )
}
